export class ViewReadyCoordinator<Step extends string> {
  private readonly readySteps = new Set<Step>();
  private emitted = false;
  private destroyed = false;

  constructor(
    private readonly requiredSteps: readonly Step[],
    private readonly emitReady: () => void,
  ) { }

  reset(): void {
    if (this.destroyed) {
      return;
    }

    this.readySteps.clear();
    this.emitted = false;
  }

  markReady(step: Step): void {
    if (this.destroyed) {
      return;
    }

    this.readySteps.add(step);
  }

  destroy(): void {
    this.destroyed = true;
    this.readySteps.clear();
  }

  tryEmit(canEmit: () => boolean = () => true): boolean {
    if (this.destroyed || this.emitted) {
      return false;
    }

    if (this.requiredSteps.some((step) => !this.readySteps.has(step))) {
      return false;
    }

    if (!canEmit()) {
      return false;
    }

    this.emitted = true;
    this.emitReady();
    return true;
  }
}
